var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 26,
    viewBox: "0 0 17 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5344 26H17V0H10.5285C4.01777 0 0.601036 3.39915 0.601036 8.41938C0.598075 12.3778 2.50037 14.8079 5.81791 17.2063L0 26H4.82457L11.299 16.1482L9.04441 14.6215C6.32568 12.7528 4.99408 11.3008 4.99408 8.15146C4.99408 5.38249 6.90674 3.51462 10.5448 3.51462H12.5344V26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexIcon);
export default __webpack_public_path__ + "static/media/YandexIcon.00710429be50326e65e9f0081bca3e5a.svg";
export { ForwardRef as ReactComponent };